'use strict';

const SoaModel = require('bunsen/models/SoaModel');
const endpoints = require('dibs-endpoints');

const TrendingItems = SoaModel.extend({
    url: endpoints.recommendations()
});

module.exports = TrendingItems;



// WEBPACK FOOTER //
// ./~/bunsen/models/identity/TrendingItem.es.js